import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { removeFromCart, updateQuantity, clearCart } from '../store/cartSlice';
import { useAuth } from '../context/AuthContext';

const Cart = () => {
  const cartItems = useSelector(state => state.cart.items);
  const dispatch = useDispatch();
  const { isLoggedIn } = useAuth();

  if (!isLoggedIn) {
    return (
      <div className="card">
        <h3>Cart</h3>
        <p>Please login to view your cart</p>
      </div>
    );
  }

  const totalAmount = cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);

  return (
    <div className="card">
      <h3>Shopping Cart</h3>
      
      {cartItems.length === 0 ? (
        <p>Your cart is empty</p>
      ) : (
        <>
          {cartItems.map(item => (
            <div key={item.id} className="cart-item">
              <div>
                <h4>{item.name}</h4>
                <p>Price: Rs {item.price} each</p>
              </div>
              <div className="cart-controls">
                <input
                  type="number"
                  min="1"
                  value={item.quantity}
                  onChange={(e) => dispatch(updateQuantity({ 
                    id: item.id, 
                    quantity: parseInt(e.target.value) 
                  }))}
                />
                <span>Rs {(item.price * item.quantity).toFixed(2)}</span>
                <button className="btn btn-danger" onClick={() => dispatch(removeFromCart(item.id))}>Remove</button>
              </div>
            </div>
          ))}
          
          <div className="total-section">
            <h4>Total: Rs {totalAmount.toFixed(2)}</h4>
            <div style={{marginTop: '15px'}}>
              <button className="btn" onClick={() => dispatch(clearCart())} style={{marginRight: '10px'}}>Clear Cart</button>
              <button className="btn btn-success">Checkout</button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Cart;